// extracted by mini-css-extract-plugin
export default {"title":"GetAdvertising_title__LfC18","boxForm":"GetAdvertising_boxForm__y0bET","form":"GetAdvertising_form__fBo1L"};